const { createSlice } = require("@reduxjs/toolkit");

const initialState = "";

const formerDealerSlice = createSlice({
    name: "formerDealer",
    initialState,
    reducers: {
        setFormerDealer: (state, action) => {
            return action.payload;
        },
        removeFormerDealer: () => {
            return initialState;
        },
    },
});

export const { setFormerDealer, removeFormerDealer } = formerDealerSlice.actions;
export default formerDealerSlice.reducer;